import type { Notification } from './types'

function payloadString(
  payload: Record<string, unknown>,
  key: string,
): string | null {
  const value = payload[key]
  if (typeof value !== 'string') return null
  const trimmed = value.trim()
  return trimmed ? trimmed : null
}

/**
 * Deep link reproduced from the frozen notifications page and the push URL
 * builder (BE-NOTIFICATIONS `pushURL`):
 *
 * - activity chat -> `/chat/{activityId}`;
 * - friend request family -> `/friends`;
 * - private message -> `/messages/{conversationId}`;
 * - any other activity payload (including waitlist types) -> `/activity/{id}`.
 *
 * Returns null when the payload cannot produce a safe in-app destination; the
 * tile still marks the row read instead of navigating to an invented route.
 */
export function notificationHref(notification: Notification): string | null {
  const payload = notification.payload ?? {}
  const activityId = payloadString(payload, 'activityId')

  if (notification.type === 'activity_chat_message') {
    return activityId ? `/chat/${encodeURIComponent(activityId)}` : null
  }

  if (notification.type.startsWith('friend_request')) {
    return '/friends'
  }

  if (notification.type === 'private_message') {
    const conversationId = payloadString(payload, 'conversationId')
    return conversationId
      ? `/messages/${encodeURIComponent(conversationId)}`
      : null
  }

  if (activityId) {
    return `/activity/${encodeURIComponent(activityId)}`
  }

  return null
}
